/**
 * Vue.js内で使える共通関数を置いておく場所
 * 関数だけでなく、パラメータもおける
 */

import marked from 'marked';
import moment from 'moment-timezone';
// momentの開発が終了したので今後の日付操作にdayjsを使用。
import dayjs from 'dayjs';

import _ from 'lodash';
Vue.prototype._ = _;
Vue.prototype.dayjs = dayjs;
Vue.prototype.marked = marked;

function getUserLanguage() {
    let language = window.user_language==""?"ja":window.user_language;
    if (/\/buyer\/market\/\d+\/bidding/.test(window.location.href)) {
        language = window.user_language==""?"en":window.user_language;
    }
    return language;
};

Vue.mixin({
    data: function() {
        return {
            messages: window.messages,
            user_language: getUserLanguage(),
            user_currency_setting: window.user_currency_setting,
            const_user_currency_setting: window.user_currency_setting
        };
    },
    filters: {
        addComma: function (value) {
            if (value) {
                return value.toLocaleString();
            }
            return 0; // 金額が無い時は、0を返す
        },
        hmTimeFormat: function (value) {
            if (!value) {
                return null;
            }
            if (value == '00:00:00') {
                return '00:00';
            }
            return moment(value, 'HH:mm:ss').tz('Asia/Tokyo').format('HH:mm');
        },
        exStateValue: function (value) {
            let status = {
                0: '未出品',
                1: '出品',
                2: '保留',
                3: '落札',
                4: '引取',
                5: '返品'
            };
            return status[value];
        }
    },
    methods: {
        getUnionName(data) {
            var name = "";
            if (data) {
                name = data.name_ja;
                if (data.name_en) {
                    name = name + ` / ${data.name_en}`;
                }
                if (data.name_ch) {
                    name = name + ` / ${data.name_ch}`;
                }
            }
            return name;
        },

    }
});
